exports = module.exports = require("../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".btnComp {\n  display: flex; \n  align-content: center;\n  justify-content: center;\n  Zoom: 80%;\n}", ""]);

